import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import Typography from "@material-ui/core/Typography";


const smallFont = {fontSize: 15};

export default function NearestOtmItmSelect({nearestOtmItm, setNearestOtmItm}) {
    return (
        <RadioGroup
            row
            aria-label="nearestOtmItm"
            name="nearestOtmItm"
            value={nearestOtmItm}
            onChange={(ev) => {
                setNearestOtmItm(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={4}>
                    <FormLabel><Typography style={smallFont}>Nearest option:</Typography></FormLabel>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="nearestOtm" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>OTM</Typography>}/>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="nearestItm" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>ITM</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}